
export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  title: '云仓收货单详情',
} as TCommon.RouteConfig
        